import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export interface TabbedFilterTitleTypographyProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    children: JSX.Element | string
}

const TabbedFilterTitleTypography = memo(({templating, children}: TabbedFilterTitleTypographyProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return (
        <Suspense>
            <ComponentName>{children}</ComponentName>
        </Suspense>
    )
})
TabbedFilterTitleTypography.displayName = "TabbedFilterTitleTypography"

export default connect(TabbedFilterTitleTypography)
